import { Button, notification, Skeleton, Space, Transfer, Slider, Switch } from 'antd';
import { BottomButtons } from 'components/SharedComponents/BottomButtons/BottomButtons';
import gql from 'graphql-tag';
import { useAuthedMutation, useAuthedQuery } from 'utils/qlAuth';
import { StoryController_copyStory, StoryController_removeStory } from './buttons';
import { useStoryFramesQuery } from 'queries/ai-threshold';
import React from 'react';
import { StoryFramesModel } from 'interface/models';

export const ImportFramesFromOtherStories = (props: { qStory: any; storyId: number }) => {
  // Состояние выбранных ключей (правой части Transfer)
  const [targetKeys, setTargetKeys] = React.useState<string[]>([]);
  const [isShort, setIsShort] = React.useState<boolean>(false);
  const [hasVideo, setHasVideo] = React.useState<boolean>(true);

  const [newFrame] = useAuthedMutation(
    gql`
      mutation StoryController_createOneFrame($storyId: Int!, $frameId: Int!, $config: JSON!) {
        StoryController_createOneFrame(storyId: $storyId, frameId: $frameId, config: $config) {
          id
        }
      }
    `,
  );

  // FrameController_getTenantFrames
  const qFrames = useAuthedQuery(
    gql`
      query FrameController_getTenantFrames($where: JSON!) {
        FrameController_getTenantFrames(where: $where) {
          id
          promt
          tts
          status
          timeStart
          timeLength
          initText
          motion
          motionPromt
          presetStyle
          images
          videos
          videoCatStop
          videoCatStart
          videoSpeed
          tags
          frameIndex
          copyFrom
        }
      }
    `,
    {
      variables: { where: {} },
    },
  );
  const ownFrames = useStoryFramesQuery(props.storyId);
  const ownFramesList: StoryFramesModel[] = ownFrames.data?.FrameController_getStoryFrames || [];

  const story = props.qStory.data?.StoryController_getStoryById || {};

  const allFrames: StoryFramesModel[] = (qFrames.data?.FrameController_getTenantFrames || [])
    .filter((frame: StoryFramesModel) => {
      // Исключаем фреймы, которые уже есть в текущей истории
      return !ownFramesList.some(ownFrame => ownFrame.id === frame.id || ownFrame.copyFrom === frame.id);
    })
    .filter((frame: StoryFramesModel) => {
      // Исключаем фреймы, которые скрыты
      return frame.status !== 'hidden';
    })
    .filter((frame: StoryFramesModel) => {
      if (frame.isShort === null || frame.isShort === undefined) {
        return true;
      }
      return frame.isShort === (isShort ? 1 : 0);
    })
    .filter((frame: StoryFramesModel) => {
      // Исключаем фреймы без видео, если hasVideo выключен
      if (hasVideo) {
        return frame.videos && frame.videos.length > 0;
      }
      return true;
    });

  // Состояние для maxHeight
  const [imgMaxHeight, setImgMaxHeight] = React.useState(40);

  // Преобразуем allFrames для Transfer
  const transferData = allFrames.map((frame: StoryFramesModel) => ({
    key: String(frame.id),
    title: frame.promt || `Frame #${frame.id}`,
    img: frame.images?.[0],
    description: frame.promt || '',
  }));

  if (props.qStory.loading || !story || qFrames.loading) {
    return <Skeleton active />;
  }

  return (
    <>
      {/* Слайдер для управления высотой картинок */}
      <Space>
        <Switch checkedChildren="Long" unCheckedChildren="Short" checked={isShort} onChange={setIsShort} title="Is short" />{' '}
        <Switch checkedChildren="Video" unCheckedChildren="Image" checked={hasVideo} onChange={setHasVideo} title="Has video" />{' '}
        <>
          <Slider min={20} max={300} value={imgMaxHeight} onChange={setImgMaxHeight} style={{ width: 180 }} />
          <span>{imgMaxHeight}px</span>
        </>
      </Space>
      <br />
      <br />
      {/* Transfer для выбора фреймов */}
      <Transfer
        dataSource={transferData}
        titles={['Все фреймы', 'Выбранные фреймы']}
        targetKeys={targetKeys}
        onChange={nextTargetKeys => setTargetKeys(nextTargetKeys.map(String))}
        render={item => (
          <Space>
            {item.img && (
              <img
                src={item.img}
                alt={item.title}
                style={{
                  maxWidth: imgMaxHeight,
                  maxHeight: imgMaxHeight,
                  objectFit: 'cover',
                  borderRadius: 4,
                }}
              />
            )}
            <span>{item.title}</span>
          </Space>
        )}
        listStyle={{ width: '48%', height: '550px' }}
        showSearch
        filterOption={(inputValue, item) =>
          (item.title || '').toLowerCase().includes(inputValue.toLowerCase()) ||
          (item.description || '').toLowerCase().includes(inputValue.toLowerCase())
        }
        pagination={{ pageSize: 10 }}
      />
      <BottomButtons
        extra={
          <>
            <StoryController_copyStory qStory={props.qStory} storyId={props.storyId} />
            <StoryController_removeStory qStory={props.qStory} storyId={props.storyId} />
          </>
        }
      >
        <Button
          type="primary"
          size="small"
          disabled={targetKeys.length === 0}
          onClick={() => {
            // Обработка импорта выбранных фреймов
            targetKeys.forEach(async key => {
              const frame = allFrames.find(f => f.id === Number(key));
              if (frame) {
                const res = await newFrame({
                  variables: {
                    storyId: props.storyId,
                    frameId: frame.id,
                    config: {
                      // no
                    },
                  },
                });

                if (res.data?.StoryController_createOneFrame) {
                  notification.success({
                    message: `Импортирован #${frame.id}`,
                  });
                }
              }
            });
          }}
        >
          Импортировать {targetKeys.length} фреймов
        </Button>
      </BottomButtons>
    </>
  );
};
// В начало, в конец или как попало?
